module.exports = __webpack_public_path__ + "img/safebox.ed0c33c4.png";